import { MessageCircle } from "lucide-react";

// WhatsApp Numbers
export const WHATSAPP_SALES = "+19548059212";
export const WHATSAPP_SUPPORT = "+19542940624";

// Format phone for display
export const formatWhatsAppNumber = (number) => {
  const cleaned = number.replace(/\D/g, '');
  if (cleaned.startsWith('1') && cleaned.length === 11) {
    return `+1 (${cleaned.slice(1,4)}) ${cleaned.slice(4,7)}-${cleaned.slice(7)}`;
  }
  return number;
};

// Generate WhatsApp URL
export const getWhatsAppUrl = (number, message = "") => {
  const cleanNumber = number.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodedMessage}` : ''}`;
};

// Sales WhatsApp Button (for Landing/Home)
export const WhatsAppSalesButton = ({ className = "" }) => {
  const message = "Hola, me interesa información sobre los servicios de Divídelo para mi visa americana.";
  
  return (
    <a
      href={getWhatsAppUrl(WHATSAPP_SALES, message)}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 ${className}`}
      data-testid="whatsapp-sales-btn"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full animate-pulse">
        Ventas
      </span>
    </a>
  );
};

// Support WhatsApp Button (for logged-in clients)
export const WhatsAppSupportButton = ({ caseId = "", clientName = "", className = "" }) => {
  const message = caseId 
    ? `Hola, soy ${clientName || 'cliente'} de Divídelo. Mi número de caso es: ${caseId}. Necesito ayuda con:`
    : `Hola, soy cliente de Divídelo. Necesito ayuda con:`;
  
  return (
    <a
      href={getWhatsAppUrl(WHATSAPP_SUPPORT, message)}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 bg-emerald-500 hover:bg-emerald-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 ${className}`}
      data-testid="whatsapp-support-btn"
      aria-label="Soporte por WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute -top-1 -right-1 bg-blue-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
        Soporte
      </span>
    </a>
  );
};

// Inline WhatsApp link for text
export const WhatsAppLink = ({ type = "sales", text = "WhatsApp", className = "" }) => {
  const number = type === "sales" ? WHATSAPP_SALES : WHATSAPP_SUPPORT;
  const message = type === "sales" 
    ? "Hola, me interesa información sobre Divídelo."
    : "Hola, soy cliente de Divídelo y necesito ayuda.";
  
  return (
    <a
      href={getWhatsAppUrl(number, message)}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-green-600 hover:text-green-700 hover:underline ${className}`}
    >
      {text}
    </a>
  );
};

export default {
  WHATSAPP_SALES,
  WHATSAPP_SUPPORT,
  WhatsAppSalesButton,
  WhatsAppSupportButton,
  WhatsAppLink,
  getWhatsAppUrl,
  formatWhatsAppNumber
};
